import React from 'react';

function FooterSection() {
  return (
    <footer className="back-purple footer-area">footer</footer>
  )
}

export default FooterSection